import { render, staticRenderFns } from "./manualBedEdit.vue?vue&type=template&id=15221f68"
import script from "./manualBedEdit.vue?vue&type=script&lang=js"
export * from "./manualBedEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports